export const RouteNames = {
  Home: 'home',
  MaterialMine: 'material-mine',
  MaterialList: 'material-list',
  MaterialListRoot: 'material-list-root',
  Demo: 'demo',
  NormalExamDetail: 'normal-exam-detail',
  ImitateExamDetail: 'imitate-exam-detail',
  PreviousExamDetail: 'previous-exam-detail',
  ExamAnswer: 'exam-answer',
  ExamResult: 'exam-result',
  ExamAnalyze: 'exam-analyze',
  ChapterList: 'chapter-list',
  ChapterListRoot: 'chapter-list-root',
  ChapterYears: 'chapter-years',
  ChapterYearsRoot: 'chapter-years-root',
  ChapterImitate: 'chapter-imitate',
  ChapterImitateRoot: 'chapter-imitate-root',
};

export const routeCnNames = {
  [RouteNames.MaterialMine]: '我的资料',
  [RouteNames.MaterialListRoot]: '组团领资料',
  [RouteNames.MaterialList]: '组团领资料',
  [RouteNames.ChapterListRoot]: '章节练习',
  [RouteNames.ChapterList]: '章节练习',
  [RouteNames.ChapterYearsRoot]: '历年试题',
  [RouteNames.ChapterYears]: '历年试题',
  [RouteNames.ChapterImitateRoot]: '模拟考场',
  [RouteNames.ChapterImitate]: '模拟考场',
};
